/**
 * @description Collect form values and trigger ajax request 
 * @return void
 */
function refreshEurojackpotQuicktippTotalAmount(){
    console.log("refreshEurojackpotQuicktippTotalAmount");

    renderQuicktippTicketDurationForHessen();

    var submitBtn = $("#button-to-basket");
    var submitBtnIsDisabled = submitBtn.prop("disabled");

    // Collect form values
    var data = {
        "drawingDays": typeof $('input[type=radio][name="drawing_day"]:checked').attr("data-label")  !== "undefined" ?  $('input[type=radio][name="drawing_day"]:checked').attr("data-label") : "f",
        "duration" : $("#laufzeit").data("duration"),
        "eurojackpotReihen" : $("#spiel-reihen").data("rows")
    }

    submitBtn.prop("disabled", true);
    $("#totalAmount").html(calculateAmount(data));

    if (!submitBtnIsDisabled) {
        submitBtn.prop("disabled", false);
    }
}

function  renderQuicktippTicketDurationForHessen() {
    if(checkEJForHessen) {
        var btnPartitionPeriod = $('*[data-participation-period="5"]');
        var drawinDay = typeof $('input[type=radio][name="drawing_day"]:checked').attr("data-label")  !== "undefined" ?  $('input[type=radio][name="drawing_day"]:checked').attr("data-label") : "f";

        if(btnPartitionPeriod) {
            var chgPartionPeriodActiveState = $("#laufzeit").data("duration") == 5;

            if(drawinDay != "k") {
                btnPartitionPeriod.removeClass( "invisible");
            } else {
                if(chgPartionPeriodActiveState) {
                    btnPartitionPeriod.removeClass( "active");
                    $('*[data-participation-period="4"]').addClass( "active");
                    $("#laufzeit").data("duration").val = 4;
                }

                btnPartitionPeriod.addClass( "invisible");
            }
        }
    }
}
